import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingHero from '../components/home/LandingHero';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import ServicesSection from '../components/home/ServicesSection';
import HowItWorks from '../components/home/HowItWorks';
import FeatureCards from '../components/home/FeatureCards';
import KeyHighlights from '../components/home/KeyHighlights';
import DonationHero from '../components/home/DonationHero';
import DownloadSection from '../components/home/DownloadSection';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL (e.g., #services, #how-it-works)
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <main>
      <LandingHero />
      <HeroSection />
      <StatsSection />
      <ServicesSection id="services" />
      <HowItWorks id="how-it-works" />
      <FeatureCards />
      <KeyHighlights />
      <DonationHero />
      <DownloadSection id="download" />
    </main>
  );
};

export default Home;